export default {"src":"/_next/static/media/IconLargeGearWetWeather.533840a9.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};